import { action, makeObservable, observable, runInAction } from 'mobx';
import {
  ContentfulProduct,
  ContentfulProductType,
  ErrorCode,
} from '@web/common';
import { getLandingPageProducts } from '../../../../../request';
import { showErrorNotification } from '../../../../../component/notification';
import { setupMobX } from '../../../../../util/setupMobX';

export class ProductsStore {
  @observable public products: null | ContentfulProduct[] = null;
  @observable public selectedProductType: ContentfulProductType =
    ContentfulProductType.Flower;

  constructor() {
    makeObservable(this);
  }

  @action public setSelectedProductType = (type: ContentfulProductType) => {
    this.selectedProductType = type;
  };

  @action public loadProducts = () => {
    getLandingPageProducts()
      .then((products) => runInAction(() => (this.products = products)))
      .catch(() => showErrorNotification(ErrorCode.ContentfulRequestError));
  };
}

const { provider, useStore } = setupMobX<ProductsStore>();
export const useProductsStore = useStore;
export const ProductsStoreProvider = provider;
